module.exports = __webpack_public_path__ + "static/media/cloud_native.a998e24b.svg";